import { render, staticRenderFns } from "./contract-record-page.vue?vue&type=template&id=d86c5bf6&scoped=true&"
import script from "./contract-record-page.vue?vue&type=script&lang=js&"
export * from "./contract-record-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86c5bf6",
  null
  
)

export default component.exports